import * as angular from "angular";
import { ApiUrl, Nav } from "../../models/app-config.model";
import { FeatureFlag } from "../../models/feature-flag.model";

interface FeatureFlagResponse {
  data: string;
}

export interface FeatureFlagService {
  (): angular.IPromise<FeatureFlag[]>;
}

/* @ngInject */
export function featureFlagService(
  FEATURE_FLAG: Object,
  FEATURE_FLAGS: string[],
  NAV: Nav,
  API_URL: ApiUrl,
  $http: angular.IHttpService,
  $q: angular.IQService
) {
  return (): angular.IPromise<FeatureFlag[]> => {
    const flagRequests = [];
    const flags = [];

    FEATURE_FLAGS.forEach(name => {
      if(FEATURE_FLAG.hasOwnProperty(name)) {
        const flag = {name: name, value: FEATURE_FLAG[name]};
        flags.push(flag);
      } else {
        flagRequests.push(
          $http.get(`${NAV.succeed_api}${API_URL.launchDarkly.replace(/:name/, name)}`)
            .then((response: FeatureFlagResponse) => {
              return response.data;
            })
            .then((value: string) => {
              const flag = {name: name, value: value};
              flags.push(flag);
              FEATURE_FLAG[flag.name] = flag.value;
            })
        );
      }
    });

    return $q
      .all(flagRequests)
      .then(() => {
        return flags;
      });
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/launch-darkly/feature-flag.service.ts